import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useApi from '../../api/useApi';
import '../../scrollbar.css';
import ShowZone from '../../components/ShowZoneForWarehouse';
import AddZone from '../../components/AddZone';
import AddWarehouse from '../../components/AddWarehouse';
import MapComponent from '../../components/MapComponent';
import Notification from '../../components/Notification';
import { useDrag, useDrop } from 'react-dnd';
import ProvisionDraggedGW from '../../components/ProvisionDraggedGW.js';

function Table() {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }

  const floorPlanRef = useRef();

  const _location = useLocation();
  const history = useHistory();

  const orgId = user && JSON.parse(sessionStorage.user).organization.id;
  const [openCreate, setOpenCreate] = useState(false);
  const [notification, setNotification] = useState(false);
  const [openWarehouse, setOpenWarehouse] = useState(false);
  const [addWarehouse, setaddWarehouse] = useState(false);
  const [type, setType] = useState();
  const [message, setMessage] = useState();

  const [state, deleteZone] = useApi();
  const [warehouseState, deleteWarehouse] = useApi();
  const [tagLocationRes, getTagLocation] = useApi();
  const [gwLocationRes, getGWLocation] = useApi();
  const [getWarehouse, setWarehouse] = useApi();
  const [zones, getZoneData] = useApi();
  const [deleteDeviceRes, deleteDevice] = useApi();

  const [selectedWarehouse, selectWarehouse] = useState();
  const [warehouse, fillWarehouse] = useState([]);
  const [onClose, setOnClose] = useState(false);
  const [popup, setPopup] = useState(false);
  const [openZone, setOpenZone] = useState(false);
  const [zoneId, setZoneId] = useState('');
  const [warehouseId, setWarehouseId] = useState('');
  const [addZone, setAddZone] = useState(false);
  const [editZone, setEditZone] = useState(false);
  const [editWarehouse, setEditWarehouse] = useState(false);
  const [id, setId] = useState(null);
  const [tagLocation, setTagLocation] = useState([]);
  const [createShape, setCreateShape] = useState(null);
  const [showFloorMap, setShowFloorMap] = useState(false);
  const [zoomedLocationFloorMap, setZoomedLocationMap] = useState();
  const [pinFlag, setPinFlag] = useState(false);
  const [search, setSearch] = useState('');
  const [gwLocation, setGWLocation] = useState([]);

  const [center, setCenter] = useState({
    lat: 32.874525,
    lng: -117.2160221,
  });
  const [coordinates, setCoordinates] = useState([center]);

  const [floormapState, uploadFloormap] = useApi();
  const [floorMap, setFloorMap] = useState('');
  const [typeMatch, setTypeMatch] = useState(true);
  const [openProvisionGW, setOpenProvisionGW] = useState(null);
  const [provisionedGWs, setProvisionedGWs] = useState([]);

  const dropsIds = useRef(0);
  const myInterval = useRef(null);
  const myInterval1 = useRef(null);

  const fileRef = useRef();

  const handleChange = (e) => {
    const fileType = ['image/jpeg', 'image/png', 'image/svg+xml'];
    const [file] = e.target.files;
    if (file) {
      if (file && fileType.includes(file.type)) {
        setFloorMap(file);
        setTypeMatch(false);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const x = new FormData();
    // var reg = /(.*?)\.(jpg|bmp|jpeg|png)$/;
    x.append('file', floorMap, floorMap.name);
    uploadFloormap(`/warehouse/${warehouseId}/floorPlan`, 'POST', x);
  };

  useEffect(() => {
    user && setWarehouse(`/organization/${orgId}/warehouses`, 'GET');
  }, []);

  useEffect(() => {
    if (!gwLocationRes.isLoading && !gwLocationRes.isError && gwLocationRes.data) {
      const gws = gwLocationRes.data.blegwIds || gwLocationRes.data.blegwLocations;
      setGWLocation(gws);

      if (Array.isArray(gws)) {
        const noLocationGWs = [];
        gws.forEach((gw) => {
          console.log(gw);
          if (!gw.x && !gw.y) {
            noLocationGWs.push(gw.blegwId);
          }
        });

        const _gateways = [];

        if (noLocationGWs.length > 0) {
          selectedWarehouse.Zones.forEach(function (zone) {
            zone.GatewayInfos.forEach((gateway) => {
              if (gateway.floorPlan) {
                console.log(gateway.deviceId, noLocationGWs);
                if (noLocationGWs.includes(gateway.deviceId)) {
                  const _coordinates = JSON.parse(gateway.floorPlan);
                  _gateways.push({ coordinates: _coordinates, id: gateway.deviceId });
                }
              }
            });
          });
          setProvisionedGWs(_gateways);
        }
      }
    }
  }, [gwLocationRes]);

  useEffect(() => {
    if (!tagLocationRes.isLoading && !tagLocationRes.isError && tagLocationRes.data) {
      if (selectedWarehouse?.attributes?.rtls !== 'QUUPPA') {
        setTagLocation(tagLocationRes.data.tagLocations);
      } else {
        const parsingArr =
          tagLocationRes.data &&
          tagLocationRes.data.tagLocations &&
          tagLocationRes.data.tagLocations.length > 0 &&
          tagLocationRes.data.tagLocations.map((x) => {
            return {
              location: JSON.parse(x.location),
              assetName: x.assetName,
              deviceId: x.deviceId,
            };
          });
        if (parsingArr) {
          setTagLocation(parsingArr);
        } else {
          setTagLocation([]);
        }
      }
    }
  }, [tagLocationRes]);

  useEffect(() => {
    console.log('warehouse', selectedWarehouse);
    if (!openZone && selectedWarehouse?.floorPlan) {
      setProvisionedGWs([]);
      setGWLocation([]);
      setTagLocation([]);

      // const _gateways = [];
      // selectedWarehouse.Zones.forEach(function (zone) {
      //   zone.GatewayInfos.forEach((gateway) => {
      //     if (gateway.floorPlan) {
      //       const _coordinates = JSON.parse(gateway.floorPlan);
      //       _gateways.push({ coordinates: _coordinates, id: gateway.deviceId });
      //     }
      //   });
      // });
      // setProvisionedGWs(_gateways);

      const blegwId = [];
      selectedWarehouse &&
        selectedWarehouse.Zones.length > 0 &&
        selectedWarehouse.Zones.map((x) => x.GatewayInfos.map((y) => blegwId.push(y.deviceId)));

      clearInterval(myInterval.current);
      clearInterval(myInterval1.current);

      if (selectedWarehouse) {
        getGWLocation(
          `/warehouse/${selectedWarehouse.id}/blegwLocation?type=${selectedWarehouse?.attributes?.rtls || 'MERAKI'
          }&date=${new Date()}`,
          'GET'
        );

        const whTagLocationUrl = `/warehouse/${selectedWarehouse.id}/tagLocation?type=${selectedWarehouse?.attributes?.rtls || 'MERAKI'
          }&date=${new Date()}`;

        myInterval1.current = setInterval(() => {
          getTagLocation(whTagLocationUrl, 'GET');
        }, 3000);
      }
    } else {
      clearInterval(myInterval1.current);
    }

    return () => {
      clearInterval(myInterval1.current);
    };
  }, [selectedWarehouse, openZone]);

  const createImgMarker = (x, marker) => {
    let _loc;
    if (x.attributes) {
      _loc = x.attributes;
    } else {
      _loc = x.location;
    }

    if (!Array.isArray(_loc)) return null;
    const mppx = selectedWarehouse.attributes ? selectedWarehouse.attributes.mppx : 0.05;
    const mppy = selectedWarehouse.attributes ? selectedWarehouse.attributes.mppy : 0.05;
    const left = _loc[0] / mppx + selectedWarehouse.attributes.leftMargin;
    const bottom = _loc[1] / mppy + (floorPlanRef?.current?.naturalHeight - selectedWarehouse.attributes.topMargin);
    const pcLeft = (left / floorPlanRef?.current?.naturalWidth) * 100;
    const pcbottom = (bottom / floorPlanRef?.current?.naturalHeight) * 100;

    return (
      <div className="wrapper absolute z-50" style={{ left: `${pcLeft}%`, bottom: `${pcbottom}%` }}>
        <div className="icon Marker">
          <div className="tooltip">{x.assetName || x.deviceId || x.tagId}</div>
          <img
            src={marker || 'assets/img/marker.svg'}
            className={`w-8 h-8 ${!marker &&
              search &&
              !(
                x?.assetName?.toLowerCase().includes(search.toLowerCase()) ||
                x?.deviceId?.toLowerCase().includes(search.toLowerCase()) ||
                x?.tagId?.toLowerCase().includes(search.toLowerCase())
              ) &&
              'opacity-20'
              }`}
          />
        </div>
      </div>
    );
  };

  const createGatewayMarker = (x) => {
    const length = selectedWarehouse.attributes ? selectedWarehouse.attributes.length : 100;
    const width = selectedWarehouse.attributes ? selectedWarehouse.attributes.width : 75;
    const left = (x.x / width) * 100;
    const bottom = (x.y / length) * 100;

    return (
      <div className="wrapper absolute z-50" style={{ left: `${left}%`, bottom: `${bottom}%` }}>
        <div className="icon Marker">
          <div className="tooltip">{x.blegwId}</div>
          <img src="assets/img/gateway_marker.svg" className="w-8 h-8" />
        </div>
      </div>
    );
  };

  const createMistGatewayMarker = (x) => {
    const height = selectedWarehouse.attributes ? selectedWarehouse.attributes.height : 100;
    const width = selectedWarehouse.attributes ? selectedWarehouse.attributes.width : 75;
    const xOrigin = selectedWarehouse.attributes ? selectedWarehouse.attributes.origin_x : 0;
    const yOrigin = selectedWarehouse.attributes ? selectedWarehouse.attributes.origin_y : height;

    const left = ((x.x - xOrigin) / width) * 100;
    const bottom = ((height - x.y - (yOrigin - height)) / height) * 100;

    return (
      <div className="wrapper absolute z-50" style={{ left: `${left}%`, bottom: `${bottom}%` }}>
        <div className="icon Marker">
          <div className="tooltip">{x.name}</div>
          <img src="assets/img/gateway_marker.svg" className="w-8 h-8" />
        </div>
      </div>
    );
  };

  const createMistTagMarker = (x) => {
    const height = selectedWarehouse.attributes ? selectedWarehouse.attributes.height_m : 100;
    const width = selectedWarehouse.attributes ? selectedWarehouse.attributes.width_m : 75;
    const xOrigin = selectedWarehouse.attributes ? selectedWarehouse.attributes.origin_x : 0;
    const yOrigin = selectedWarehouse.attributes ? selectedWarehouse.attributes.origin_y : height;

    const left = ((x.x) / width) * 100;
    const bottom = ((x.y) / height) * 100;

    return (
      <div className="wrapper absolute z-50" style={{ left: `${left}%`, bottom: `${bottom}%` }}>
        <div className="icon Marker">
          <div className="tooltip">{x.assetName || x.deviceId}</div>
          <img
            src="assets/img/Marker.png"
            className={`w-8 h-8 ${search &&
              !(
                x.assetName.toLowerCase().includes(search.toLowerCase()) ||
                x.deviceId.toLowerCase().includes(search.toLowerCase())
              ) &&
              'opacity-20'
              }`}
          />
        </div>
      </div>
    );
  };

  const createImgDiv = (data) => {
    const length = selectedWarehouse.attributes ? selectedWarehouse.attributes.length : 100;
    const width = selectedWarehouse.attributes ? selectedWarehouse.attributes.width : 75;
    const left = (data.x / width) * 100;
    const bottom = (data.y / length) * 100;

    return (
      <div className="wrapper absolute z-50" style={{ left: `${left}%`, bottom: `${bottom}%` }}>
        <div className="icon Marker">
          <div className="tooltip">{data.assetName || data.deviceId}</div>
          <img
            src="assets/img/Marker.png"
            className={`w-8 h-8 ${search &&
              !(
                data.assetName.toLowerCase().includes(search.toLowerCase()) ||
                data.deviceId.toLowerCase().includes(search.toLowerCase())
              ) &&
              'opacity-20'
              }`}
          />
        </div>
      </div>
    );
    // }
  };

  const createShapesForMIRAKI = (x) => {
    if (x.direction && x.shape === 'CIRCLE') {
      const height = selectedWarehouse.attributes
        ? (x.direction.radius * 2 * 100) / selectedWarehouse.attributes.length
        : x.direction.radius * 2;
      const width = selectedWarehouse.attributes
        ? (x.direction.radius * 2 * 100) / selectedWarehouse.attributes.width
        : x.direction.radius * 2;
      const left = selectedWarehouse.attributes
        ? (100 * Math.abs(x.direction.center[0] - x.direction.radius)) / selectedWarehouse.attributes.width
        : x.direction.center[0] - x.direction.radius;
      const bottom = selectedWarehouse.attributes
        ? (100 * Math.abs(x.direction.center[1] - x.direction.radius)) / selectedWarehouse.attributes.length
        : x.direction.center[1] - x.direction.radius;
      return (
        <div
          className="absolute border-dashed border-2 border-indigo-600 z-50"
          style={{
            height: `${height}%`,
            left: `${left}%`,
            bottom: `${bottom}%`,
            borderRadius: `100%`,
            width: `${width}%`,
            background: '#8ec5e547',
            opacity: '0.5',
          }}
        />
      );
    }
    if (x.direction && x.shape === 'RECTANGLE') {
      const { dimension, start } = x.direction;
      const width = (100 * dimension[0]) / selectedWarehouse.attributes?.width;
      const height = (100 * dimension[1]) / selectedWarehouse.attributes?.length;
      const left = (100 * start[0]) / selectedWarehouse.attributes?.width;
      const bottom = (100 * start[1]) / selectedWarehouse.attributes?.length;

      return (
        <div
          className="absolute border-dashed border-2 border-indigo-600 z-50"
          style={{
            height: `${height}%`,
            left: `${left}%`,
            bottom: `${bottom}%`,
            width: `${width}%`,
            background: '#8ec5e547',
            opacity: '0.5',
          }}
        />
      );
    }
  };

  const createShapesForQUUPAA = (x) => {
    const mppx = selectedWarehouse.attributes ? selectedWarehouse.attributes.mppx : 0.05;
    const mppy = selectedWarehouse.attributes ? selectedWarehouse.attributes.mppy : 0.05;
    if (x.direction && x.shape === 'CIRCLE') {
      const height = selectedWarehouse.attributes
        ? (100 * ((x.direction.radius * 2) / mppy)) / selectedWarehouse.attributes.topMargin
        : x.direction.radius * 2;

      const width = selectedWarehouse.attributes
        ? (100 * ((x.direction.radius * 2) / mppx)) /
        (floorPlanRef?.current?.naturalWidth - selectedWarehouse.attributes.leftMargin)
        : x.direction.radius * 2;

      const left = selectedWarehouse.attributes
        ? (100 *
          (Math.abs((x.direction.center[0] - x.direction.radius) / mppx) + selectedWarehouse.attributes.leftMargin)) /
        (floorPlanRef?.current?.naturalWidth - selectedWarehouse.attributes.leftMargin)
        : x.direction.center[0] - x.direction.radius;

      const bottom = selectedWarehouse.attributes
        ? (100 *
          (Math.abs((x.direction.center[1] - x.direction.radius) / mppy) +
            (floorPlanRef?.current?.naturalHeight - selectedWarehouse.attributes.topMargin))) /
        selectedWarehouse.attributes.topMargin
        : x.direction.center[1] - x.direction.radius;

      return (
        <div
          className="absolute border-dashed border-2 border-indigo-600 z-50"
          style={{
            height: `${height}%`,
            left: `${left}%`,
            bottom: `${bottom}%`,
            borderRadius: `100%`,
            width: `${width}%`,
            background: '#8ec5e547',
            opacity: '0.5',
          }}
        />
      );
    }
    if (x.direction && x.shape === 'RECTANGLE') {
      const { dimension, start } = x.direction;
      const width =
        (100 * (dimension[0] / mppx)) / (floorPlanRef?.current?.naturalWidth - selectedWarehouse.attributes.leftMargin);

      const height = (100 * (dimension[1] / mppy)) / selectedWarehouse.attributes?.topMargin;

      const left = selectedWarehouse.attributes
        ? (100 * (Math.abs(start[0] / mppx) + selectedWarehouse.attributes.leftMargin)) /
        (floorPlanRef?.current?.naturalWidth - selectedWarehouse.attributes.leftMargin)
        : x.direction.center[0] - x.direction.radius;

      const bottom = selectedWarehouse.attributes
        ? (100 *
          (Math.abs(start[1] / mppy) +
            (floorPlanRef?.current?.naturalHeight - selectedWarehouse.attributes.topMargin))) /
        selectedWarehouse.attributes.topMargin
        : x.direction.center[1] - x.direction.radius;

      return (
        <div
          className="absolute border-dashed border-2 border-indigo-600 z-50"
          style={{
            height: `${height}%`,
            left: `${left}%`,
            bottom: `${bottom}%`,
            width: `${width}%`,
            background: '#8ec5e547',
            opacity: '0.5',
          }}
        />
      );
    }
  };

  useEffect(() => {
    if (!getWarehouse.isLoading && !getWarehouse.isError && getWarehouse.data) {
      const warehouseLocation = [];
      getWarehouse?.data?.warehouses.map((x) =>
        warehouseLocation.push({ lat: parseFloat(x?.Address?.latitude), lng: parseFloat(x?.Address?.longitude) })
      );
      fillWarehouse(getWarehouse?.data?.warehouses);
      setCoordinates(warehouseLocation);
    }
  }, [getWarehouse]);

  useEffect(() => {
    if (!zones.isLoading && !zones.isError && zones.data) {
      selectWarehouse({ ...selectedWarehouse, Zones: zones.data.zones });
    }

    if (!zones.isLoading && zones.isError && zones.data) {
      selectWarehouse({ ...selectedWarehouse, Zones: [] });
    }
  }, [zones.isLoading, zones.isError, zones.data]);

  const toggleOpenZone = (prev) => {
    setOpenZone((prev) => !prev);
  };

  const toggleAddZone = (prev) => {
    setAddZone(false);
    setEditZone(false);
  };

  const toggleAddWarehouse = (prev) => {
    setaddWarehouse(false);
    setEditWarehouse(false);
  };

  const refreshList = () => {
    toggleAddZone();
    setWarehouse(`/organization/${orgId}/warehouses`, 'GET');
    getZoneData(`/warehouse/${warehouseId}/zones`, 'GET');
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const handleDelete = () => {
    deleteZone(`/zone/${zoneId}`, 'DELETE');
  };

  const handleDeleteWarehpuse = () => {
    deleteWarehouse(`/warehouse/${warehouseId}`, 'DELETE');
  };

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setZoneId('');
      setMessage('Zone deleted successfully');
      refreshList();
      setOnClose(false);
      setType('success');
      setNotification(!notification);
    }
  }, [state]);

  useEffect(() => {
    if (!warehouseState.isLoading && !warehouseState.isError && warehouseState.data) {
      setWarehouseId('');
      setMessage('Warehouse deleted successfully');
      setPopup(false);
      setType('success');
      refreshList();
      setNotification(!notification);
    }
  }, [warehouseState]);

  const [{ isDragging }, drag] = useDrag(() => ({
    // "type" is required. It is used by the "accept" specification of drop targets.
    type: 'BOX',

    // The collect function utilizes a "monitor" instance (see the Overview for what this is)
    // to pull important pieces of state from the DnD system.
    collect: (monitor) => ({
      // isDragging: monitor.isDragging(),
    }),
  }));

  const [{ canDrop, isOver, getClientOffset }, drop] = useDrop(() => ({
    // The type (or types) to accept - strings or symbols
    accept: 'BOX',
    drop: (item, monitor) => handleDropItem(item, monitor),
    // Props to collect
    collect: (monitor) => ({
      // isOver: monitor.isOver(),
      // canDrop: monitor.canDrop(),
      // getClientOffset: monitor.getClientOffset(),
    }),
  }));

  const handleDropItem = (item, monitor) => {
    const z = floorPlanRef.current.getBoundingClientRect();
    const offset = monitor.getClientOffset();

    let k = {
      id: dropsIds.current,
      x: offset.x - z.x,
      y: offset.y - z.y,
    };

    setOpenProvisionGW(k);
    dropsIds.current += 1;
  };

  const removeItems = (x) => {
    deleteDevice(`/devices/assets`, 'DELETE', { device: [x.id] });
  };

  useEffect(() => {
    console.log(deleteDeviceRes);
    if (!deleteDeviceRes.isLoading && !deleteDeviceRes.isError && deleteDeviceRes.data) {
      setMessage('Device deleted successfully');
      setOnClose(false);
      setType('success');

      setNotification(!notification);
      refreshList();
    }
    if (deleteDeviceRes.isError) {
      setType('error');
      setMessage('Something went wrong');
      setNotification(!notification);
    }
  }, [deleteDeviceRes]);

  return (
    <>
      {openProvisionGW && (
        <ProvisionDraggedGW
          handleClose={() => setOpenProvisionGW(null)}
          zones={selectedWarehouse.Zones}
          address={selectedWarehouse.Address}
          openProvisionGW={openProvisionGW}
          refreshList={refreshList}
        />
      )}
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      {onClose && (
        <div className="flex justify-center items-center h-full w-full fixed z-20 devices_back">
          <div className="bg-white w-3/12 px-2 text-sm block m-auto rounded-2xl relative mobile_toggle">
            <span className="block font-bold border-b p-4 text-textBlue1">Delete Zone</span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-4 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnClose(false)}
            />
            <span className="block text-center text-sm mt-8 mb-8" style={{ color: '#9B9B9B' }}>
              Do you want to delete Zone?
            </span>
            <div className="mb-6 font-bold flex items-center justify-center">
              <div className="w-2/3 lg:flex sm:block">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 lg:w-max w-auto border px-8 py-4 rounded-3xl text-xs font-semibold text-role mr-2 focus:outline-none flex justify-center items-center h-6"
                  onClick={() => {
                    setOnClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-semibold focus:outline-none flex justify-center items-center h-6 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {popup && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20 devices_back"
        // style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-3/12 px-2 text-sm block m-auto rounded-2xl relative mobile_toggle">
            <span className="block font-bold border-b p-4 text-textBlue1">Delete Warehouse</span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-4 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setPopup(false)}
            />
            <span className="block text-center text-sm mt-8 mb-8" style={{ color: '#9B9B9B' }}>
              Do you want to delete Warehouse?
            </span>
            <div className="mb-6 font-bold flex items-center justify-center">
              {/* <div className="w-1/3" /> */}
              <div className="w-2/3 lg:flex sm:block">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 lg:w-max w-auto border px-8 py-4 rounded-3xl text-xs font-semibold text-role mr-2 focus:outline-none flex justify-center items-center h-6"
                  onClick={() => {
                    setPopup(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-semibold focus:outline-none flex justify-center items-center h-6 bg-btnBg text-white"
                  onClick={handleDeleteWarehpuse}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openWarehouse && (
        <div
          className="h-full fixed hideScroll m-8 w-full left-44 view_width "
          style={{ filter: openCreate && 'blur(2px)', overflow: 'auto', left: '14%', width: '81%' }}
        >
          {/* search */}
          {selectedWarehouse.floorPlan && !openZone && (
            <div className="absolute w-1/5 border z-10 bg-white px-4 py-2 rounded-3xl flex justify-between items-center ">
              <input
                type="text"
                placeholder="Search Asset/Device"
                autoComplete="off"
                className="text-textBox text-xs bg-transparent w-full focus:outline-none"
                value={search}
                name="q"
                onChange={(e) => setSearch(e.target.value)}
                style={{ borderColor: '#e6e6e6' }}
              />
              <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
            </div>
          )}

          <div
            className="w-full relative flex items-center justify-center h-screen map_zone"
            style={{ height: '94vh' }}
          >
            {selectedWarehouse.floorPlan
              ? !openZone && (
                <div className="absolute left-1/4 top-2 bottom-2 mr-14" ref={drop} role={'Dustbin'}>
                  <div className="relative w-full h-full">
                    <img
                      ref={floorPlanRef}
                      className="w-full h-full bg-fixed"
                      src={selectedWarehouse.floorPlan}
                      alt=""
                    />
                    {selectedWarehouse.Zones &&
                      selectedWarehouse.Zones.length > 0 &&
                      selectedWarehouse.Zones.map((x) =>
                        selectedWarehouse?.attributes?.rtls === 'QUUPPA'
                          ? createShapesForQUUPAA(x)
                          : createShapesForMIRAKI(x)
                      )}
                    {tagLocation &&
                      tagLocation.length > 0 &&
                      tagLocation.map((x) =>
                        selectedWarehouse?.attributes?.rtls === 'QUUPPA'
                          ? createImgMarker(x)
                          : selectedWarehouse?.attributes?.rtls === 'MERAKI'
                            ? createImgDiv(x)
                            : createMistTagMarker(x)
                      )}
                    {gwLocation &&
                      gwLocation.length > 0 &&
                      gwLocation.map((x) =>
                        selectedWarehouse?.attributes?.rtls === 'QUUPPA'
                          ? createImgMarker(x, 'assets/img/gateway_marker.svg')
                          : selectedWarehouse?.attributes?.rtls === 'MERAKI'
                            ? createGatewayMarker(x)
                            : createMistGatewayMarker(x)
                      )}

                    {provisionedGWs.map((x) => (
                      <div
                        className="wrapper absolute transform -translate-x-1/2 -translate-y-1/2 cursor-pointer z-50"
                        style={{ left: x.coordinates.x, top: x.coordinates.y }}
                        onDoubleClick={() => removeItems(x)}
                      >
                        <div className="icon w-20">
                          <div className="tooltip">{x.id}</div>
                          <img src={'assets/img/Gateway.svg'} className="w-10 h-auto" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
              : selectedWarehouse?.attributes?.rtls !== 'Tag-N-Trac' && (
                <div className="w-2/5 rounded-xl m-auto mt-40 bg-white">
                  <form className="mt-2 mb-2 flex flex-wrap " onSubmit={handleSubmit} autoComplete="off">
                    <div className="w-full relative">
                      <p className="font-bold text-sm text-textBlue1 border-b p-4 pb-1">
                        Upload Floor Map of Warehouse {selectedWarehouse.name}
                      </p>
                      <div className="flex items-center">
                        <div
                          className="inputLabelText px-4 mt-6 py-4 focus:outline-none relative text-sm cursor-pointer"
                          style={{ width: '92%', left: '4%', color: '#9B9B9B' }}
                          onClick={() => fileRef.current.click()}
                        >
                          <img src="assets/img/upload2.svg" className="w-5 mr-3 absolute right-0" alt="" />
                          <input
                            ref={fileRef}
                            onChange={handleChange}
                            multiple={false}
                            type="file"
                            accept="image/*"
                            hidden
                          />
                          Upload Floor Map
                        </div>
                        <span className="mt-5 relative mr-2 ml-4 text-xs p-2">
                          {floorMap !== null ? floorMap.name : ''}
                          {floorMap !== null && floorMap.name ? (
                            <img
                              src="assets/img/Close.svg"
                              className="absolute top-2 right-0 h-2 cursor-pointer"
                              alt=""
                              onClick={() => setFloorMap(null)}
                            />
                          ) : null}
                        </span>
                      </div>
                    </div>

                    <div className="w-full flex mt-5 mb-2 relative ml-auto">
                      {floormapState.isLoading ? (
                        <img src="assets/img/loader.svg" className="absolute w-16 right-36 mx-auto bottom-0" alt="" />
                      ) : (
                        <>
                          <span className="text-red-400 w-2/5 ml-4 floorCss">
                            *Filetype could be .jpg, .jpeg, .png and .svg
                          </span>
                          <div className="w-1/10" />
                          <button
                            type="submit"
                            className="rounded-3xl w-2/5 float-right focus:outline-none h-10 text-white bg-primary cursor-pointer "
                            style={{ border: '1px solid #16406D' }}
                            disabled={typeMatch}
                          >
                            Save
                          </button>
                        </>
                      )}
                    </div>
                  </form>
                </div>
              )}
          </div>

          <div className="absolute z-50 w-full top-12 flex">
            {/* {!zones.isLoading && ( */}
            <div className="exampleZones border bg-tableBg absolute h-screen shadow-md max-w-screen-xl mx-auto sm:w-full w-1/5 px-3 py-3">
              {selectedWarehouse.Zones.length > 0 ? (
                <>
                  <div className="flex items-center justify-between">
                    <h1 className="text-base text-titleColor font-bold bg-white ml-3 mb-2">Zones</h1>
                    <div className="flex items-center justify-center">
                      <div
                        className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile3"
                        onClick={() => {
                          setOpenZone(false);
                          setPinFlag(true);
                          setOpenWarehouse(false);
                          setGWLocation([]);
                          setTagLocation([]);
                          selectWarehouse(null);
                        }}
                      >
                        Back
                      </div>
                      <div
                        className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile6"
                        onClick={() => {
                          setAddZone(true);
                        }}
                      >
                        Add
                      </div>
                    </div>
                  </div>
                  <p className="text-xs ml-3 mt-2">in {selectedWarehouse.name}</p>
                </>
              ) : (
                <div className="flex items-center justify-between">
                  <h1 className="text-base text-titleColor text-center bg-white ml-3 mb-2">No Zones Available</h1>
                  <div
                    className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile3"
                    onClick={() => {
                      setOpenZone(false);
                      setPinFlag(true);
                      setOpenWarehouse(false);
                      setGWLocation([]);
                      setTagLocation([]);
                      selectWarehouse(null);
                    }}
                  >
                    Back
                  </div>
                  <div
                    className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile3"
                    onClick={() => {
                      setAddZone(true);
                    }}
                  >
                    Add
                  </div>
                </div>
              )}
              <div
                className="pb-1 wareos hideScroll"
                style={{ borderColor: '#e6e6e6', height: '78vh', overflow: 'auto', borderBottom: 'none' }}
              >
                {selectedWarehouse.Zones.length > 0 &&
                  selectedWarehouse.Zones.map((item, idx) => (
                    <div
                      tabIndex={idx}
                      className="my-2 pl-3 py-1 bg-white flex rounded-md
                  shadow-sm relative border focus:bg-rowSelect hover:bg-rowSelect"
                    >
                      <div className=" py-1 text-xs w-full flex items-center">
                        <p
                          className="font-bold text-textBlue1 capitalize text-sm truncate full-width cursor-pointer whitespace-nowrap overflow-hidden overflow-ellipsis"
                          onClick={(e) => {
                            setId(e.target.id);
                            setOpenZone(true);
                            setZoneId(item.id);
                            setPinFlag(false);
                          }}
                          id={idx}
                        >
                          {` ${item.name !== null ? item.name : 'undefined'}`}
                        </p>
                        <div className="flex w-full items-end justify-between">
                          <div className="flex my-0 mt-1.5 text-titleColor font-medium text-xs">
                            {item?.geoLocation}
                          </div>
                          <div className="flex items-end justify-end">
                            <img
                              src="assets/img/Edit2.svg"
                              className="h-3 mt-1 cursor-pointer"
                              alt=""
                              onClick={() => {
                                setAddZone(true);
                                setEditZone(true);
                                setZoneId(item.id);
                              }}
                            />
                            <img
                              src="assets/img/Delete_Blue.svg"
                              className="h-5 pt-1 -mb-0.5 cursor-pointer"
                              alt=""
                              onClick={() => {
                                setOnClose(true);
                                setZoneId(item.id);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            {zones.isLoading && <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />}
            {openZone && (
              <div className="border absolute bg-white zonething">
                <ShowZone
                  zoneData={selectedWarehouse.Zones[id]}
                  type={selectedWarehouse.attributes.rtls || 'MERAKI'}
                  handleClose={toggleOpenZone}
                  hasFloorMap={!!selectedWarehouse.floorPlan}
                />
              </div>
            )}
            {addZone && (
              <AddZone
                handleClose={toggleAddZone}
                notification={createNotification}
                refreshList={() => refreshList()}
                editZone={editZone}
                zoneId={zoneId}
                warehouseId={warehouseId}
                selectedWarehouse={selectedWarehouse}
              />
            )}
          </div>
        </div>
      )}
      {!openWarehouse && (
        <div
          className="h-full fixed hideScroll m-8 w-full left-44 view_width "
          style={{ filter: openCreate && 'blur(2px)', overflow: 'auto', left: '14%', width: '81%' }}
        >
          <MapComponent
            selectedPage="warehouse"
            coordinates={coordinates}
            center={center}
            selectedData={warehouse}
            setShowFloorMap={setShowFloorMap}
            setZoomedLocationMap={setZoomedLocationMap}
          />

          <div className="flex mr-2 absolute top-0 left-0 z-60">
            <button
              className={`${_location.pathname.includes('zones') ? 'bg-btnBg text-white' : 'text-black bg-gray-400'
                } px-4 h-7 text-xs focus:outline-none`}
              onClick={() => {
                localStorage.setItem('warehouseORzone', 'zones');
                history.push('/zones');
              }}
            >
              Zones
            </button>
            <button
              className={`${_location.pathname.includes('warehouse') ? 'bg-btnBg text-white' : 'text-black bg-gray-400'
                } px-4 h-7 text-xs focus:outline-none`}
              onClick={() => {
                localStorage.setItem('warehouseORzone', 'warehouses');
                history.push('/warehouses');
              }}
            >
              Warehouses
            </button>
          </div>

          <div className="absolute z-50 w-full top-12 flex">
            {!getWarehouse.isLoading && (
              <div className="exampleZones border bg-tableBg absolute h-screen shadow-md max-w-screen-xl mx-auto sm:w-full w-1/5 px-3 py-3">
                {warehouse.length > 0 ? (
                  <div className="flex items-center justify-between">
                    <h1 className="text-base text-titleColor font-bold bg-white ml-3 mb-2">Warehouses</h1>
                    <div
                      className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile1"
                      onClick={() => {
                        setaddWarehouse(true);
                      }}
                    >
                      Add
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center justify-between">
                    <h1 className="text-base text-titleColor text-center bg-white ml-3 mb-2">No Warehouse Available</h1>
                    <div
                      className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs cursor-pointer font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile1"
                      onClick={() => {
                        setaddWarehouse(true);
                      }}
                    >
                      Add
                    </div>
                  </div>
                )}
                <div
                  className="pb-1 wareos hideScroll"
                  style={{ borderColor: '#e6e6e6', height: '78vh', overflow: 'auto', borderBottom: 'none' }}
                >
                  {warehouse.length > 0 &&
                    // !openZone &&
                    warehouse.map((item, idx) => (
                      <div
                        className="my-2 pl-3 py-1 bg-white flex rounded-md
                  shadow-sm relative border hover:border-indigo-200 focus-within:border-indigo-200"
                      >
                        <div className=" py-1 text-xs w-full">
                          <p
                            className="font-bold text-textBlue1 capitalize text-sm cursor-pointer whitespace-nowrap overflow-hidden overflow-ellipsis"
                            onClick={(e) => {
                              setId(e.target.id);
                              setOpenWarehouse(true);
                              selectWarehouse(item);
                              setPinFlag(false);
                              setWarehouseId(item.id);
                            }}
                            id={idx}
                          >
                            {` ${item.name !== null ? item.name : 'undefined'}`}
                          </p>
                          <div className="flex items-center justify-between my-0 mt-1.5 text-titleColor font-medium text-xs">
                            {item?.Address?.country}

                            <div className="flex items-end justify-end ml-auto">
                              <img
                                src="assets/img/Edit2.svg"
                                className="h-3 mt-1 cursor-pointer"
                                alt=""
                                onClick={() => {
                                  setaddWarehouse(true);
                                  setEditWarehouse(true);
                                  setWarehouseId(item.id);
                                }}
                              />
                              <img
                                src="assets/img/Delete_Blue.svg"
                                className="h-5 pt-1 -mb-0.5 cursor-pointer"
                                alt=""
                                onClick={() => {
                                  setPopup(true);
                                  setWarehouseId(item.id);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
            {zones.isLoading && <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />}

            {/* {openZone && (
              <div className="border absolute bg-white" style={{ width: '78%', left: '21%', height: '83vh' }}>
                <ShowZone gatewayData={selectedWarehouse.Zones[id]} handleClose={toggleOpenZone} />
              </div>
            )} */}

            {addWarehouse && (
              <AddWarehouse
                handleClose={toggleAddWarehouse}
                notification={createNotification}
                refreshList={() => refreshList()}
                editWarehouse={editWarehouse}
                warehouseId={warehouseId}
              />
            )}

            {/* {
             addZone && (
              <AddZone
              handleClose={toggleAddZone}
              notification={createNotification}
              refreshList={() => refreshList()}
              editZone={editZone}
              zoneId={zoneId}
            />
             )
           } */}
          </div>
        </div>
      )}

      {/* draggable item */}
      {selectedWarehouse?.floorPlan
        ? !openZone && (
          <div
            className="absolute right-4 top-10 w-18 bg-white py-4 border border-gray-300 shadow-lg rounded-lg"
            style={{ height: '91vh' }}
          >
            <img ref={drag} className="w-10 h-auto bg-fixed mx-auto" src="assets/img/Gateway.svg" alt="" />
          </div>
        )
        : null}
    </>
  );
}

export default Table;
